import $              from 'jquery';
import VideoClip      from "../core/videoClip";
import useTimeMachine from "../core/useTimeMachine";
import RealTimeWatch  from "../core/realtimeWatch";

const timeMachine = useTimeMachine('EPT', (storedState) =>{
  setState(storedState);
});

const $ctx = $('#eptColl');
const $mainTabWrap = $ctx.find('.tab_rwd.tab_rwd_box');
const $listTab = $mainTabWrap.find('.list_tab');
const $listTabItems = $listTab.children(); // li
const $mainPanels = $ctx.find('.coll_cont .tab_body .cont_wrap');

const state = {
  tabIdx:0,
  tabName:''
};

render(
  MainTab(state),
  MainPanel(state)
);
setToolTip();
setInitialState();
initCountDownTimer($ctx);
togglePanelsOnTabClick();
moreScoreView();
setVClip();
setVClipList();
timeMachine.check();

/**
 * 야구에서만 사용됩니다.
 * 경기결과가 9회차 이상인 경우에만 페이지를 넘기도록 하는 함수.
 * 담당자 : @rain
 * > 테이블의 td 를 넘길 수 있다.
 * > 스포츠 1차 개편의 시안과 2차 개변의 시안이 상이하여 사용될지는 미지수.
 */
function moreScoreView(){
  const $tblBaseBall = $ctx.find('.tbl_baseball');
  const $nextBtn = $tblBaseBall.find('.btn_score_r');
  const $prevBtn = $tblBaseBall.find('.btn_score_l');
  const $innigScore = $tblBaseBall.find('thead th');
  const inningAllScore = $innigScore.length - 4; //allScore - R/H/S
  const $inning = $tblBaseBall.find('tbody tr');
  const $homeInnig = $inning.eq(0).find('td');
  const $awayInnig = $inning.eq(1).find('td');
  let $scoreNum = $innigScore.slice(1, inningAllScore + 1); //<th> slice tit,R/H/s
  const $homeScoreNum = $homeInnig.slice(1, inningAllScore + 1); //<td> slice tit,R/H/s
  const $awayScoreNum = $awayInnig.slice(1, inningAllScore + 1); //<td> slice tit,R/H/s

  function sliceNum(sliceElem){
    let sliceNum = 9; //chunk num = show
    let startCurrentNum = -9; //start idx (-n : start lastNum)
    let displaySelector; //selector.slice( startIdx, endIdx )
    let startIdx;
    let endIdx;
    let $scoreNum = sliceElem;

    function clickToggleClass(){
      $scoreNum.addClass('hide');
      displaySelector.removeClass('hide');
      startCurrentNum = startIdx;
    }

    function whenTargetLowerSliceNum(start, end){
      endIdx = startIdx + sliceNum;
      displaySelector = $scoreNum.slice(startIdx, endIdx);

      if(displaySelector.length < sliceNum){
        startIdx = start;
        endIdx = end;
        displaySelector = $scoreNum.slice(start, end);
      }
    }

    function changeBtnClass(){
      if(inningAllScore === sliceNum){
        $prevBtn.addClass('left_off');
        $nextBtn.addClass('right_off');
      }

      if(!$innigScore.eq(1).hasClass('hide')){
        $prevBtn.addClass('left_off');
        $nextBtn.removeClass('right_off');
      }else if(!$innigScore.eq(inningAllScore).hasClass('hide')){
        $nextBtn.addClass('right_off');
        $prevBtn.removeClass('left_off');
      }else{
        $nextBtn.removeClass('right_off');
        $prevBtn.removeClass('left_off');
      }
    }

    changeBtnClass();

    function moreViewPrev(){
      startIdx = startCurrentNum - sliceNum;

      whenTargetLowerSliceNum(0, sliceNum);
      clickToggleClass();
      changeBtnClass();
    }

    function moreViewNext(){
      const lastTargetDoneMove = $scoreNum.last().hasClass('hide');
      if(!lastTargetDoneMove){
        $prevBtn.removeClass('left_off');
        return false;
      }
      startIdx = startCurrentNum + sliceNum;
      whenTargetLowerSliceNum(-sliceNum, $scoreNum.length);
      clickToggleClass();
      changeBtnClass();


    }

    $prevBtn.on('click', moreViewPrev);
    $nextBtn.on('click', moreViewNext);
  }

  sliceNum($scoreNum);
  sliceNum($homeScoreNum);
  sliceNum($awayScoreNum);


}

function setState(newState){
  $.extend(state, newState);
  $(state).trigger('update');
}

function setInitialState(){
  setState({ tabIdx:$listTabItems.filter('.on').index() });
}

function togglePanelsOnTabClick(){
  $listTab.on('click', 'li', function(){
    const $this = $(this);
    setState({ tabIdx:$this.index() }
    );
  });
}

function render(...fns){
  $(state).on('update', function(){
    fns.forEach(fn => fn());
    timeMachine.storage.set(state);
  });
}

function setVClipList(){
  const $highlightListType = $ctx.find('.highlight_cont.list_type');
  if($highlightListType.length > 0){
    new VideoClip({
      listSelector:'.highlight_cont.list_type',
      $context:$ctx,
      rendingType:'inner-list', //외부 렌더링시 basic 내부 삽입시 inner-list
      rowCount:3,
      vclipSelector:'_vClipBox_list', // 이것으로 아이디가 생성됩니다 # 포함 금지
      removeSelector:'.video_player'
    });
  }
}
function setVClip(){
  const $highlightListType = $ctx.find('.highlight_cont:not(.list_type)');
  if($highlightListType.length > 0){
    new VideoClip({
      listSelector:'.highlight_cont:not(.list_type)',
      $context:$ctx
    });
  }
}

function initCountDownTimer($ctx) {
  if(!($ctx.find('.cont_worldcup').length > 0)){
    return;
  }
  if(!($ctx.find('.play_season .match_score').length > 0)){
    return;
  }
  const $target = $ctx.find('.match_score');
  const startTime = ('' + $target.data('starttime')).slice(0, 14);
  const $timeIndicator = $target.find('.txt_time');

  if (typeof startTime !== 'string' || startTime.length !== 14) {
    return;
  }

  const countdownWatch = new RealTimeWatch(startTime, (diff) => {
    if (diff.reduce((a, b) => a + b) <= 0) {
      countdownWatch.stop();
      $timeIndicator.text('00:00:00');
    } else {
      $timeIndicator.text(diff.map(RealTimeWatch.addZero).join(':'));
    }
  });

  countdownWatch.start();

  return countdownWatch;
}

function setToolTip(){
  if(!($ctx.find('.info_adsch.info_fairtrade').length > 0)){
    return;
  }
  const $toolTip = $ctx.find('.info_adsch.info_fairtrade');

  $toolTip.on('click','.ico_rwd.ico_help', function(){
    $toolTip.find('.layer_ad').toggleClass('on');
  });

  $toolTip.on('click','.btn_close', function(){
    $toolTip.find('.layer_ad.on').removeClass('on');
  });

}

// UI Components
function MainTab(state){
  return () =>{
    $listTabItems.removeClass('on');
    $listTabItems.eq(state.tabIdx).addClass('on');
  };
}

function MainPanel(state){
  return () =>{
    $mainPanels.addClass('hide');
    $mainPanels.eq(state.tabIdx).removeClass('hide');
  };
}




/** WEBPACK FOOTER **
 ** ./src/sports/EPT/index.js
 **/